import React, { useState, useEffect } from "react";
import Button from "../components/form/Button";
import Header from "../components/Header";
import axiosInstance from "../utils/axiosInstance";
import Session from "../utils/sessionStorage";
import SubscribePackageModal from "../components/SubscribePackageModal";
import ErrorModal from "../components/ErrorModal";
import SuccessModal from "../components/SuccessModal";
import { X_API_KEY } from "../constants/ServerUrl";
import ShimmerSkeleton from "../components/ShimmerSkeleton";
import nodata from "../assets/images/nodata.png";

const ExtendValidity = () => {
  const [loading , setLoading] = useState(false);
  const [loadingDataPakages , setLoadingDataPakages] = useState(true);
  const [validityPakages, setValidityPakages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataPrice , setDataPrice] = useState(null);
  const [errorModal, setErrorModal] = useState({ open: false, message: "" });
  const [successModal, setSuccessModal] = useState({ open: false, message: "" });
  const openModal = (packagename , price) => {
    setSelectedPackage(packagename);
    setDataPrice(price);
    setIsModalOpen(true);
    console.log("pakage " , packagename);
    console.log("price " , price);
  };

  console.log("validitypakages" , validityPakages)

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPackage(null);
    setDataPrice(null);
  };

  const token = Session.get("token");
  const profile = Session.get("_user_");
  const userData = profile ? JSON.parse(profile) : "";

  const handleSubscribe = async () => {
    const userMob = userData.mobileNo;
    var body = {
      msisdn: userMob,
      package: selectedPackage,
    //   amount: dataPrice,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "api/v2/buy-data-validity",
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-API-KEY": X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setLoading(false)
        setSuccessModal({ open: true, message: "Subscribed Successfully" });
      }
    } catch (error) {
      setLoading(false)
      setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to subscribe" });
    }
    closeModal();
    setLoading(false)
  };
  async function getValidityPackages() {
    setLoadingDataPakages(true)
    try {
      const response = await axiosInstance.get("/api/v2/get-validity-packages",
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        },
      );
      if (response.status === 200) {
        const { validity_packages } = response?.data;
        setValidityPakages(validity_packages);
      }
    } catch (error) {
      setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to load validity packages" });
    }finally{
      setLoadingDataPakages(false)
    }
  }

  useEffect(() => {
    getValidityPackages();
  }, []);
  return (
    <div className="bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto">
      <Header />
      {loadingDataPakages ? (<ShimmerSkeleton/>) : (
        validityPakages.length === 0 ? (
          <div className="flex flex-col justify-center  bg-white mt-[33px] h-44 rounded-lg mb-3">
                <div className="mx-auto">
                  <img src={nodata} alt="no data" className="w-full h-full" />
                </div>
                <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                  No Extend Validity Packages Available
                </p>
              </div>
        ) : (
          <div className="space-y-2.5 pt-6 mx-4">
        {validityPakages?.map((data, index) => {
          return (
            <div
              key={index}
              className=" p-4 flex flex-col gap-3  border-[2px] border-white bg-gradient-to-r from-white to-red-200  h-auto rounded-lg"
            >
              <h3 className="text-secondary font-poppins font-bold text-base inline text-[1.2rem]">
                {data?.packageName}
              </h3>
              <div className="border-t-[1px] border-white"></div>
              <div className="space-y-1.5">
                <div className="flex items-center gap-3 gap-x-6">
                  <div>
                    <p className="text-[13px] text-accent-grey-900">Data Validity</p>
                    <h3 className="flex justify-center items-center">
                      {data?.dataValidity } Days
                    </h3>
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center">
                <span className="font-poppins text-base font-bold text-[1.2rem] text-secondary">
                  RM {Number(data?.price).toFixed(2)}
                </span>
                <Button
                  eventAction={() => openModal(data?.packageName , data?.price)}
                  type={"primary"}
                  size={"xxlg"}
                  children={"Subscribe"}
                />
              </div>
            </div>
          );
        })}
      </div>
        )
      )}

      <div className="container">
        <div className="py-5"></div>
      </div>
      <SubscribePackageModal isOpen={isModalOpen} onClose={closeModal} onConfirm={handleSubscribe} packagename={selectedPackage} packageprice={dataPrice} loading={loading}/>
      
      {/* Error Modal */}
      {errorModal.open && (
        <ErrorModal
          message={errorModal.message}
          close={() => setErrorModal({ open: false, message: "" })}
        />
      )}

      {/* Success Modal */}
      {successModal.open && (
        <SuccessModal
          message={successModal.message}
          close={() => setSuccessModal({ open: false, message: "" })}
        />
      )}
    </div>
  );
};

export default ExtendValidity;
